import { render, staticRenderFns } from "./AdvPixelBlock.vue?vue&type=template&id=f1b6f7f8"
import script from "./AdvPixelBlock.vue?vue&type=script&lang=js"
export * from "./AdvPixelBlock.vue?vue&type=script&lang=js"
import style0 from "./AdvPixelBlock.vue?vue&type=style&index=0&id=f1b6f7f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports